<template>
  <div>
    <div class="w-full h-screen flex flex-col justify-center items-center">
      <div class="flex items-center p-5">
        <div class="text-3xl px-4 text-gray-800 tracking-wider border-r-2 border-gray-800">
          404
        </div>
        <div class="text-2xl p-4 text-gray-800">
          {{ $t("lang.msg.pageNotFound") }}
        </div>
      </div>
      <div class="flex justify-end items-end w-56">
        <ButtonRedirect route="home">
          {{ $t("lang.msg.backToHome") }}
        </ButtonRedirect>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>
